export default (theme) => ({
    root: {
        width: '100%',
        height: 'calc(100% - 40px)',
        marginTop: '40px',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        overflow: 'auto',
        padding: '16px 0',
        boxSizing: 'border-box',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.primary.white,
        ...theme.utils.scrollbar,
    },
    emptyView: {
        maxWidth: 340,
        textAlign: 'center',
        margin: [0, 'auto'],

        illustration: {
            maxHeight: 144,
            height: '18vh',
            marginBottom: 14,
            '& .fm-entity-list__empty-first-icon': {
                width: 80,
                display: 'inline-block',
            },
        },
    },
    emptyViewLast: {
        maxWidth: 440,
        textAlign: 'center',
        margin: [0, 'auto'],

        '& img': {
            width: '100%',
            maxWidth: '100%',
            borderRadius: 25,
            boxShadow:
                '0 1px 8px 0 rgba(39, 60, 80, 0.2), 0 3px 4px 0 rgba(39, 60, 80, 0.12), 0 3px 3px 0 rgba(39, 60, 80, 0.14)',
            cursor: 'pointer',
            marginBottom: 24,
        },
    },
    title: {
        marginBottom: 8,
    },
    description: {
        marginBottom: 24,
    },
    button: {
        marginRight: 8,
        marginBottom: 8,
        display: 'inline-block',
        '&:last-child': {
            marginRight: 0,
        },
    },
});
